import { render, staticRenderFns } from "./ListaSku.vue?vue&type=template&id=b3f0805c&scoped=true&"
import script from "./ListaSku.vue?vue&type=script&lang=js&"
export * from "./ListaSku.vue?vue&type=script&lang=js&"
import style0 from "./ListaSku.vue?vue&type=style&index=0&id=b3f0805c&prod&lang=scss&scoped=true&"
import style1 from "./ListaSku.vue?vue&type=style&index=1&id=b3f0805c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f0805c",
  null
  
)

export default component.exports